import React, { useState } from 'react';
import { Drawer } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components/macro';
import styledFuncs from 'app/styles/styledFuncs';
import styledMixins from 'app/styles/styledMixins';
import styledConsts from 'app/styles/styledConsts';
import AppImage from 'app/shared/components/app-image/AppImage';
import { RepairCase } from 'app/core/api/repairer/api-repairer.types';
import { RatingReq } from 'app/core/api/rating/api-rating.types';
import ReactStars from 'react-rating-stars-component';
import Button from 'app/shared/components/button/Button';
import ClassName from 'app/styles/ClassName';
import { useCreateRating } from 'app/core/api/rating/api-rating';
import { useShowInfo } from 'app/shared/context-hooks/use-show-info.hook';
import SharedRoutePath from 'app/shared/SharedRoutePath';
import { makeStyles } from '@material-ui/core/styles';
import { DefaultUserImg } from '../../components/misc';
import { IWRepairerSvg } from '../../components/icon/icon-lib';

const imgHeight = 99;
const useStyles = makeStyles({
  drawerPaper: {
    height: '70%',
    borderRadius: '10px 10px 0 0',
  },
});

const RatingContainer = styled.div`
  display: block;
  padding: 18px 0;
`;

const RatingPageTitle = styled.div`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  /*  display: flex; */
  align-items: center;
  text-align: center;
`;

const RatingPageDesc = styled.div`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  /* display: flex; */
  align-items: center;
  text-align: center;
`;

const ImageContainer = styled.div`
  text-align: center;
  margin: 20px auto;
  .defaultImg {
    display: inline-flex;
  }
`;

const StandardImage = styled(AppImage)`
  ${styledMixins.roundCorners}
  ${styledMixins.roundCorners}
  display: inline-block;
  justify-content: center;
  align-items: flex-start;
  height: ${imgHeight}px;
  width: ${imgHeight}px;
  min-width: ${imgHeight * 0.8}px;
  flex-shrink: 10000;
  padding: 0;
`;

const RatingStarBox = styled.div`
  text-align: center;
  padding-top: 16px;
  padding-bottom: 6px;
  .custom-rating {
    display: inline-block;
  }
  .custom-rating span,
  .custom-rating span:before {
    padding: 0 5px;
  }
`;
const CompactButtonContainer = styled.div`
  text-align: center;
  padding-bottom: 15px;
`;
const CompactButton = styled(Button).attrs({
  slim: true,
  className: ClassName.NO_HEIGHT_MARGIN,
})`
  width: 70%;
  margin-top: ${styledFuncs.pad()};
  margin-bottom: ${styledFuncs.pad(0.5)};
`;

const SkipButtonContainer = styled.div`
  text-align: center;
`;

const SkipButton = styled(Button).attrs({
  slim: true,
  className: ClassName.NO_HEIGHT_MARGIN,
})`
  margin-top: ${styledFuncs.pad()};
  margin-bottom: ${styledFuncs.pad(0.5)};
  color: ${styledConsts.cError};
  background-color: transparent;
  padding: 0;
  min-height: 0;
  margin: 0;
  &:hover {
    background-color: transparent;
  }
`;

type Props = {
  isRatingOpen: boolean;
  setIsRatingOpen: (isVisible: boolean) => unknown;
  repairCase?: RepairCase;
};

export default function Rating({
  isRatingOpen,
  setIsRatingOpen,
  repairCase,
}: Props): JSX.Element {
  const history = useHistory();
  const classes = useStyles();
  const { showSnack } = useShowInfo();
  const { request$: addRatingReq$ } = useCreateRating();
  const [showSubmit, setShowSubmit] = useState(false);
  const [rating, setRating] = useState(0);
  const ratingChanged = (newRating: number) => {
    setRating(newRating);
    if (newRating >= 1) {
      setShowSubmit(true);
    } else {
      setShowSubmit(false);
    }
  };

  const handleSkipRequest = () => {
    // history.goBack();
    setIsRatingOpen(false);
  };
  const handleSubmitRatingRequest = () => {
    const addRating: RatingReq = {
      repairCaseId: repairCase?.id ?? 0,
      rate: rating,
    };
    addRatingReq$(addRating).subscribe(() => {
      showSnack({
        message: `Rating successfully submitted!`,
      });
      // history.goBack();
      setIsRatingOpen(false);
      history.push(SharedRoutePath.HOME);
    });
  };
  const otherUsersImg = repairCase?.repairerDetails?.logo ? (
    <StandardImage
      alt="repairer profile"
      src={repairCase?.repairerDetails?.logo}
      fallbackImgNode={<IWRepairerSvg width={imgHeight} />}
    />
  ) : (
    <DefaultUserImg className="defaultImg" size={imgHeight} />
  );

  return (
    <Drawer
      anchor="bottom"
      open={isRatingOpen}
      onClose={() => setIsRatingOpen(false)}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <RatingContainer>
        <RatingPageTitle>How would you rate</RatingPageTitle>
        <RatingPageTitle>
          {repairCase?.repairerDetails?.displayName}?
        </RatingPageTitle>
        <ImageContainer>{otherUsersImg}</ImageContainer>
        <RatingPageDesc>
          Your rating helps both our repairer
        </RatingPageDesc>
        <RatingPageDesc>and community. Thank you:)</RatingPageDesc>
        <RatingStarBox>
          <ReactStars
            className="custom-rating"
            count={5}
            onChange={ratingChanged}
            size={40}
            activeColor="#f9d12"
            value={rating}
            edit
          />
        </RatingStarBox>
        {showSubmit && (
          <CompactButtonContainer>
            <CompactButton
              onClick={handleSubmitRatingRequest}
              /*   
          to={
            openRepairCaseId
              ? `${SharedRoutePath.CHAT}/${openRepairCaseId}`
              : `${ConsumerRoutePath.PRODUCT_REPORT_FAULT}/${id}`
          } 
          pending={loadingOpenCase}
          */
            >
              Submit
            </CompactButton>
          </CompactButtonContainer>
        )}
        <SkipButtonContainer>
          <SkipButton
            onClick={
              handleSkipRequest
            } /*  to={`${ConsumerRoutePath.VIEW_ASSIGNED_PRODUCT}/${repairCase?.id}`} */
          >
            Skip
          </SkipButton>
        </SkipButtonContainer>
      </RatingContainer>
    </Drawer>
  );
}
